import CurrencyFormatter from './CurrencyFormatter';
import FallbackCurrencyFormatter from './FallbackCurrencyFormatter';

const { app } = window.tnew;

let currencyFormatter: CurrencyFormatter;

function getCurrencyFormatterSync() {
  if (currencyFormatter) {
    return currencyFormatter;
  }

  let Class = CurrencyFormatter;

  if (!window.Intl) {
    Class = FallbackCurrencyFormatter;
  }

  currencyFormatter = new Class(app.bcp47LanguageTag, app.iso4217CurrencyCode);

  return currencyFormatter;
}

/**
 * @deprecated Use synchronous function instead
 */
async function getCurrencyFormatter() {
  return getCurrencyFormatterSync();
}

export default getCurrencyFormatter;

export {
  getCurrencyFormatterSync,
};
